import { ButtonA, PaperA, ScrollView } from "@src/ruix";
import { ScrollViewWithButtonProps } from "@src/ruix/types";

const ScrollViewWithButton = ({ children, buttonArray, ...rest }: ScrollViewWithButtonProps) => (
	<PaperA px={0} order="column-center-center" variant="white" fullWidth gap={30}>
		<ScrollView {...rest}>{children}</ScrollView>
		<PaperA variant="transparent" px={10} fullWidth order="row-center-end" gap={20}>
			{buttonArray.map((button, index) => (
				<ButtonA
					key={`${index}+ScrollViewWithButton`}
					{...button}
					size="large"
					sx={{
						px: "40px",
						py: "10px",
					}}
				/>
			))}
		</PaperA>
	</PaperA>
);

export default ScrollViewWithButton;
